var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": {
          minWidth: "100vw",
          maxWidth: "100vw",
          minHeight: "100vh"
        }
      },
      model: {
        value: _vm.show_dashboard,
        callback: function($$v) {
          _vm.show_dashboard = $$v
        },
        expression: "show_dashboard"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "fas fa-times" },
                on: {
                  click: function($event) {
                    _vm.show_dashboard = false
                  }
                }
              }),
              _c("q-toolbar-title", [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm.$t("overview")) +
                    "\n          "
                )
              ])
            ],
            1
          ),
          _c("div", { staticClass: "layout-padding" }, [
            _c("div", { staticClass: "row reverse q-mb-sm" }, [
              _vm.loaded_data
                ? _c("div", { staticClass: "col-xs-12 col-sm-4 text-right" }, [
                    _c(
                      "span",
                      { staticClass: "q-subheading text-weight-light" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("last_update_in") + " " + _vm.updated_date
                          )
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ]),
            _vm.loaded_data
              ? _c("div", { staticClass: "row gutter-md" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-6 col-lg-4" },
                    [
                      _c("totals", {
                        attrs: {
                          title: _vm.$t("user"),
                          active: _vm.users.qty_active_users,
                          active_lb: _vm.$t("active", {
                            count: _vm.users.qty_active_users
                          }),
                          inactive: _vm.users.qty_inactive_users,
                          inactive_lb: _vm.$t("inactive", {
                            count: _vm.users.qty_inactive_users
                          }),
                          deleted: _vm.users.qty_deleted_users,
                          deleted_lb: _vm.$t("deleted", {
                            count: _vm.users.qty_deleted_users
                          }),
                          self_registered_lb: _vm.$t("self_registered", {
                            count: _vm.users.qty_auto_register_users
                          }),
                          self_registered: _vm.users.qty_auto_register_users,
                          pre_registered_lb: _vm.$t("pre_registered", {
                            count: _vm.users.qty_pre_register_users
                          }),
                          pre_registered: _vm.users.qty_pre_register_users,
                          others_lb: _vm.$t("other", {
                            count: _vm.users.qty_other_users
                          }),
                          others: _vm.users.qty_other_users,
                          icon: "far fa-user",
                          module_type: "users"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.clientModules.has_courses
                    ? _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-6 col-lg-4" },
                        [
                          _c("totals", {
                            attrs: {
                              title: _vm.$t("training"),
                              active: _vm.trainings.qty_published_trainings,
                              active_lb: _vm.$t("published", {
                                count: _vm.trainings.qty_published_trainings
                              }),
                              inactive: _vm.trainings.qty_unpublished_trainings,
                              inactive_lb: _vm.$t("unpublished", {
                                count: _vm.trainings.qty_unpublished_trainings
                              }),
                              deleted: _vm.trainings.qty_deleted_trainings,
                              deleted_lb: _vm.$t("deleted", {
                                count: _vm.trainings.qty_deleted_trainings
                              }),
                              certificates:
                                _vm.trainings.qty_total_user_results,
                              certificates_lb: _vm.$t("certificate", {
                                count: _vm.trainings.qty_total_user_results
                              }),
                              icon: "fas fa-graduation-cap",
                              module_type: "training"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.clientModules.has_trails
                    ? _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-6 col-lg-4" },
                        [
                          _c("totals", {
                            attrs: {
                              title: _vm.$t("trails"),
                              active: _vm.trails.qty_published_trails,
                              active_lb: _vm.$t("published", {
                                count: _vm.trails.qty_published_trails
                              }),
                              inactive: _vm.trails.qty_unpublished_trails,
                              inactive_lb: _vm.$t("unpublished", {
                                count: _vm.trails.qty_unpublished_trails
                              }),
                              deleted: _vm.trails.qty_deleted_trails,
                              deleted_lb: _vm.$t("deleted", {
                                count: _vm.trails.qty_deleted_trails
                              }),
                              certificates: _vm.trails.qty_total_user_results,
                              certificates_lb: _vm.$t("certificate", {
                                count: _vm.trails.qty_total_user_results
                              }),
                              icon: "fas fa-sign",
                              module_type: "trails"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.clientModules.has_presential
                    ? _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-6 col-lg-4" },
                        [
                          _c("totals", {
                            attrs: {
                              title: _vm.$t("presential"),
                              active: _vm.presentials.qty_presential_schedule,
                              active_lb: _vm.$t("scheduled", {
                                count: _vm.presentials.qty_presential_schedule
                              }),
                              inactive:
                                _vm.presentials.qty_presential_waiting_results,
                              inactive_lb: _vm.$t("awaiting_result", {
                                count:
                                  _vm.presentials.qty_presential_waiting_results
                              }),
                              deleted: _vm.presentials.qty_presential_finished,
                              deleted_lb: _vm.$t("finished", {
                                count: _vm.presentials.qty_presential_finished
                              }),
                              certificates:
                                _vm.presentials.qty_total_user_results,
                              certificates_lb: _vm.$t("certificate", {
                                count: _vm.presentials.qty_total_user_results
                              }),
                              icon: "fas fa-chalkboard-teacher",
                              module_type: "presential"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.clientModules.has_webcasts
                    ? _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-6 col-lg-4" },
                        [
                          _c("totals", {
                            attrs: {
                              title: _vm.$t("webinar"),
                              active: _vm.webcasts.qty_published_webcasts,
                              active_lb: _vm.$t("published", {
                                count: _vm.webcasts.qty_published_webcasts
                              }),
                              inactive: _vm.webcasts.qty_finished_webcasts,
                              inactive_lb: _vm.$t("finished", {
                                count: _vm.webcasts.qty_finished_webcasts
                              }),
                              deleted: _vm.webcasts.qty_deleted_webcasts,
                              deleted_lb: _vm.$t("deleted", {
                                count: _vm.webcasts.qty_deleted_webcasts
                              }),
                              certificates: _vm.webcasts.qty_total_user_results,
                              certificates_lb: _vm.$t("certificate", {
                                count: _vm.webcasts.qty_total_user_results
                              }),
                              icon: "fas fa-broadcast-tower",
                              module_type: "webcast"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.clientModules.has_live_classes
                    ? _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-6 col-lg-4" },
                        [
                          _c("totals", {
                            attrs: {
                              title: _vm.$t("training"),
                              active:
                                _vm.live_classes.qty_published_live_classes,
                              active_lb: _vm.$t("published", {
                                count:
                                  _vm.live_classes.qty_published_live_classes
                              }),
                              inactive:
                                _vm.live_classes.qty_unpublished_live_classes,
                              inactive_lb: _vm.$t("unpublished", {
                                count:
                                  _vm.live_classes.qty_unpublished_live_classes
                              }),
                              deleted:
                                _vm.live_classes.qty_deleted_live_classes,
                              deleted_lb: _vm.$t("deleted", {
                                count: _vm.live_classes.qty_deleted_live_classes
                              }),
                              others:
                                _vm.live_classes.qty_finished_live_classes,
                              others_lb: _vm.$t("finished", {
                                count:
                                  _vm.live_classes.qty_finished_live_classes
                              }),
                              certificates:
                                _vm.live_classes.qty_total_user_results,
                              certificates_lb: _vm.$t("certificate", {
                                count: _vm.live_classes.qty_total_user_results
                              }),
                              icon: "fas fa-chalkboard-teacher",
                              module_type: "live_class"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm.loaded_data
              ? _c("div", { staticClass: "row gutter-md q-mt-lg" }, [
                  _vm.$q.platform.is.desktop && _vm.clientModules.has_courses
                    ? _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c(
                            "q-card",
                            { staticClass: "full-height" },
                            [
                              _c(
                                "q-card-title",
                                { staticClass: "bg-secondary" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "q-headline text-white" },
                                    [
                                      _c("q-icon", {
                                        attrs: { name: "fas fa-tasks" }
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("training_progress")) +
                                          "\n                            "
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c("q-card-separator"),
                              _c("q-card-main", [
                                _c(
                                  "div",
                                  { staticClass: "row gutter-sm" },
                                  [
                                    _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row text-weight-medium q-title"
                                        },
                                        [
                                          _c("div", { staticClass: "col-3" }, [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(_vm.$t("profiles")) +
                                                "\n                                        "
                                            )
                                          ]),
                                          _c("div", { staticClass: "col-3" }, [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(_vm.$t("users")) +
                                                "\n                                        "
                                            )
                                          ]),
                                          _c("div", { staticClass: "col-3" }, [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.$t("published_trainings")
                                                ) +
                                                "\n                                        "
                                            )
                                          ]),
                                          _c("div", { staticClass: "col-3" }, [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(_vm.$t("certificates")) +
                                                "\n                                        "
                                            )
                                          ])
                                        ]
                                      )
                                    ]),
                                    _vm._l(_vm.profiles, function(
                                      profile,
                                      index
                                    ) {
                                      return _c(
                                        "div",
                                        { key: index, staticClass: "col-12" },
                                        [
                                          _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              { staticClass: "col-3" },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(profile.profile) +
                                                    "\n                                        "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "col-3" },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(profile.users) +
                                                    "\n                                        "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "col-3" },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      profile.training_published
                                                    ) +
                                                    "\n                                        "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "col-3" },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      profile.training_results
                                                    ) +
                                                    "\n                                        "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "col-12" },
                                              [
                                                _c("q-slider", {
                                                  attrs: {
                                                    min: 0,
                                                    max: _vm.getMax(
                                                      profile.users,
                                                      profile.training_published
                                                    ),
                                                    step: 1,
                                                    label: "",
                                                    "label-always": "",
                                                    readonly: "",
                                                    "label-value":
                                                      _vm.getPercentage(
                                                        profile.users,
                                                        profile.training_results,
                                                        profile.training_published
                                                      ) + "%"
                                                  },
                                                  model: {
                                                    value:
                                                      profile.training_results,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        profile,
                                                        "training_results",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "profile.training_results"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ])
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.$q.platform.is.desktop && _vm.clientModules.has_trails
                    ? _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c(
                            "q-card",
                            { staticClass: "full-height" },
                            [
                              _c(
                                "q-card-title",
                                { staticClass: "bg-secondary" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "q-headline text-white" },
                                    [
                                      _c("q-icon", {
                                        attrs: { name: "fas fa-sign" }
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("trail_progress")) +
                                          "\n                            "
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c("q-card-separator"),
                              _c("q-card-main", [
                                _c(
                                  "div",
                                  { staticClass: "row gutter-sm" },
                                  [
                                    _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row text-weight-medium q-title"
                                        },
                                        [
                                          _c("div", { staticClass: "col-3" }, [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(_vm.$t("profiles")) +
                                                "\n                                        "
                                            )
                                          ]),
                                          _c("div", { staticClass: "col-3" }, [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(_vm.$t("users")) +
                                                "\n                                        "
                                            )
                                          ]),
                                          _c("div", { staticClass: "col-3" }, [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.$t("published_trails")
                                                ) +
                                                "\n                                        "
                                            )
                                          ]),
                                          _c("div", { staticClass: "col-3" }, [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(_vm.$t("certificates")) +
                                                "\n                                        "
                                            )
                                          ])
                                        ]
                                      )
                                    ]),
                                    _vm._l(_vm.profiles, function(
                                      profile,
                                      index
                                    ) {
                                      return _c(
                                        "div",
                                        { key: index, staticClass: "col-12" },
                                        [
                                          _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              { staticClass: "col-3" },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(profile.profile) +
                                                    "\n                                        "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "col-3" },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(profile.users) +
                                                    "\n                                        "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "col-3" },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      profile.trail_published
                                                    ) +
                                                    "\n                                        "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "col-3" },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      profile.trail_results
                                                    ) +
                                                    "\n                                        "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "col-12" },
                                              [
                                                _c("q-slider", {
                                                  attrs: {
                                                    min: 0,
                                                    max: _vm.getMax(
                                                      profile.users,
                                                      profile.trail_published
                                                    ),
                                                    step: 1,
                                                    label: "",
                                                    "label-always": "",
                                                    readonly: "",
                                                    "label-value":
                                                      _vm.getPercentage(
                                                        profile.users,
                                                        profile.trail_results,
                                                        profile.trail_published
                                                      ) + "%"
                                                  },
                                                  model: {
                                                    value:
                                                      profile.trail_results,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        profile,
                                                        "trail_results",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "profile.trail_results"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ])
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.$q.platform.is.mobile && _vm.clientModules.has_courses
                    ? _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c(
                            "q-card",
                            [
                              _c(
                                "q-card-title",
                                { staticClass: "bg-secondary" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "q-headline text-white" },
                                    [
                                      _c("q-icon", {
                                        attrs: { name: "fas fa-tasks" }
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("training_progress")) +
                                          "\n                            "
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c("q-card-separator"),
                              _c("q-card-main", [
                                _c(
                                  "div",
                                  { staticClass: "row" },
                                  _vm._l(_vm.profiles, function(
                                    profile,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "col-12 q-mb-md"
                                      },
                                      [
                                        _c("div", { staticClass: "row" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-12 q-subheading text-weight-regular"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(_vm.$t("profiles")) +
                                                  ": " +
                                                  _vm._s(profile.profile) +
                                                  "\n                                        "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-12 q-subheading text-weight-regular"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(_vm.$t("users")) +
                                                  ": " +
                                                  _vm._s(profile.users) +
                                                  "\n                                        "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-12 q-subheading text-weight-regular"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "published_trainings"
                                                    )
                                                  ) +
                                                  ": " +
                                                  _vm._s(
                                                    profile.training_published
                                                  ) +
                                                  "\n                                        "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-12 q-subheading text-weight-regular"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    _vm.$t("certificates")
                                                  ) +
                                                  ": " +
                                                  _vm._s(
                                                    profile.training_results
                                                  ) +
                                                  "\n                                        "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "col-12" },
                                            [
                                              _c("q-slider", {
                                                attrs: {
                                                  min: 0,
                                                  max: _vm.getMax(
                                                    profile.users,
                                                    profile.training_published
                                                  ),
                                                  step: 1,
                                                  label: "",
                                                  "label-always": "",
                                                  readonly: "",
                                                  "label-value":
                                                    _vm.getPercentage(
                                                      profile.users,
                                                      profile.training_results,
                                                      profile.training_published
                                                    ) + "%"
                                                },
                                                model: {
                                                  value:
                                                    profile.training_results,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      profile,
                                                      "training_results",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "profile.training_results"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ])
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.$q.platform.is.mobile && _vm.clientModules.has_trails
                    ? _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c(
                            "q-card",
                            [
                              _c(
                                "q-card-title",
                                { staticClass: "bg-secondary" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "q-headline text-white" },
                                    [
                                      _c("q-icon", {
                                        attrs: { name: "fas fa-sign" }
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("trail_progress")) +
                                          "\n                            "
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c("q-card-separator"),
                              _c("q-card-main", [
                                _c(
                                  "div",
                                  { staticClass: "row" },
                                  _vm._l(_vm.profiles, function(
                                    profile,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "col-12 q-mb-md"
                                      },
                                      [
                                        _c("div", { staticClass: "row" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-12 q-subheading text-weight-regular"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(_vm.$t("profiles")) +
                                                  ": " +
                                                  _vm._s(profile.profile) +
                                                  "\n                                        "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-12 q-subheading text-weight-regular"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(_vm.$t("users")) +
                                                  ": " +
                                                  _vm._s(profile.users) +
                                                  "\n                                        "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-12 q-subheading text-weight-regular"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    _vm.$t("published_trails")
                                                  ) +
                                                  ": " +
                                                  _vm._s(
                                                    profile.trail_published
                                                  ) +
                                                  "\n                                        "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-12 q-subheading text-weight-regular"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    _vm.$t("certificates")
                                                  ) +
                                                  ": " +
                                                  _vm._s(
                                                    profile.trail_results
                                                  ) +
                                                  "\n                                        "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "col-12" },
                                            [
                                              _c("q-slider", {
                                                attrs: {
                                                  min: 0,
                                                  max: _vm.getMax(
                                                    profile.users,
                                                    profile.trail_published
                                                  ),
                                                  step: 1,
                                                  label: "",
                                                  "label-always": "",
                                                  readonly: "",
                                                  "label-value":
                                                    _vm.getPercentage(
                                                      profile.users,
                                                      profile.trail_results,
                                                      profile.trail_published
                                                    ) + "%"
                                                },
                                                model: {
                                                  value: profile.trail_results,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      profile,
                                                      "trail_results",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "profile.trail_results"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ])
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }